module.exports = __webpack_public_path__ + "img/egg_cheese.1f940e55.jpg";